class SearchScopeManager {
  static STORAGE_KEY = 'yutaka_search_scope';

  static SCOPE_MAP = {
    all: { type: '', view: '' },
    product: { type: 'product', view: '' },
    blog: { type: 'article', view: 'news' },
    recipe: { type: 'article', view: 'recipes' },
  };

  constructor() {
    this.containers = document.querySelectorAll('[data-search-scope]');
    if (!this.containers.length) return;

    this.containers.forEach((container) => {
      const form = container.closest('form');
      if (!form) return;

      const typeInput = form.querySelector('[data-search-scope-type]');
      const viewInput = form.querySelector('[data-search-scope-view]');
      const fromUrl = container.dataset.searchScopeFromUrl === 'true';
      const urlScope = container.dataset.searchScopeActive;
      const storedScope = this.getStoredScope();
      const rawKey = fromUrl ? urlScope : storedScope || urlScope || 'all';
      const initialKey = SearchScopeManager.SCOPE_MAP[rawKey] ? rawKey : 'all';

      this.setScope(container, typeInput, viewInput, initialKey, false);

      container.querySelectorAll('[data-search-scope-option]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const key = button.dataset.searchScopeOption;
          this.syncAllForms(key);
        });
      });
    });
  }

  setScope(container, typeInput, viewInput, key, persist) {
    const config = SearchScopeManager.SCOPE_MAP[key] || SearchScopeManager.SCOPE_MAP.all;

    if (typeInput) {
      if (config.type) {
        typeInput.name = 'type';
        typeInput.value = config.type;
        typeInput.disabled = false;
      } else {
        typeInput.removeAttribute('name');
        typeInput.value = '';
        typeInput.disabled = true;
      }
    }

    if (viewInput) {
      if (config.view) {
        viewInput.name = 'view';
        viewInput.value = config.view;
        viewInput.disabled = false;
      } else {
        viewInput.removeAttribute('name');
        viewInput.value = '';
        viewInput.disabled = true;
      }
    }

    container.querySelectorAll('[data-search-scope-option]').forEach((button) => {
      const isActive = button.dataset.searchScopeOption === key;
      button.classList.toggle('search-scope__pill--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    container.dataset.searchScopeActive = key;

    if (persist) {
      this.storeScope(key);
    }
  }

  syncAllForms(key) {
    document.querySelectorAll('[data-search-scope]').forEach((container) => {
      const form = container.closest('form');
      if (!form) return;

      const typeInput = form.querySelector('[data-search-scope-type]');
      const viewInput = form.querySelector('[data-search-scope-view]');
      this.setScope(container, typeInput, viewInput, key, false);
    });

    this.storeScope(key);
  }

  getStoredScope() {
    try {
      const stored = sessionStorage.getItem(SearchScopeManager.STORAGE_KEY);
      return stored && SearchScopeManager.SCOPE_MAP[stored] ? stored : null;
    } catch (error) {
      return null;
    }
  }

  storeScope(key) {
    try {
      sessionStorage.setItem(SearchScopeManager.STORAGE_KEY, key);
    } catch (error) {
      /* ignore */
    }
  }
}

if (!window.__searchScopeManagerInitialized) {
  window.__searchScopeManagerInitialized = true;

  const initSearchScope = () => {
    window.__searchScopeManager = new SearchScopeManager();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchScope);
  } else {
    initSearchScope();
  }
}
